import SimplifiedSummary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import { selectContract, selectIsLoggedIn } from './loginSlice'
import SocialBtn from 'components/buttons/SocialBtn'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import * as nativeApp from 'utils/nativeApp'
import { useSelector } from 'react-redux'
import { selectConfig } from 'appSlice'
import { useEffect } from 'react'
import Form from './Form'
import './style.scss'

const Login = ({ isDesktop = false }) => {
  const isBasketEmpty = useSelector(selectBasketIsEmpty)
  const isLogin = useSelector(selectIsLoggedIn)
  const contract = useSelector(selectContract)
  const config = useSelector(selectConfig)

  const { replace, push } = useHistory()
  const { t } = useTranslation('form')

  useEffect(() => {
    if (isLogin) replace(
      isBasketEmpty
        ? '/dashboard'
        : contract ? '/contract' : '/order/billing'
    )
  }, [contract, isLogin, isBasketEmpty, replace])

  return (
    <>
      <div className='login'>
        <div className='login__title title'>
          <div>{t('logIn')}</div>
        </div>

        <div className='center'>
          <div className='login__main'>
            <Form />

            <div className='login__register'>
              <hr />
              <p>{t('doNotHaveAnAccount')}</p>
              <p
                className='--secFont'
                onClick={() => push('/registration')}>
                {t('signUp')}
              </p>
              <hr />
            </div>

            {(config?.oauth?.apple || config?.oauth?.google) && <div className='login__options'>
              {config?.oauth?.apple && <SocialBtn
                type='apple'
                onClick={() => {
                  if (nativeApp.checkIsNativeApp()) {
                    nativeApp.openAuth(config.oauth.apple)
                  } else {
                    window.open(config.oauth.apple, '_self')
                  }
                }} />}
              {config?.oauth?.google && <SocialBtn
                type='google'
                onClick={() => {
                  if (nativeApp.checkIsNativeApp()) {
                    nativeApp.openAuth(config.oauth.google)
                  } else {
                    window.open(config.oauth.google, '_self')
                  }
                }} />}
            </div>}
          </div>
        </div>
      </div>

      {isDesktop && !isBasketEmpty && <div className='orderInfo__aside'>
        <SimplifiedSummary />
      </div>}
    </>
  )
}

export default Login